module.exports = __webpack_public_path__ + "chelsea-96a536e71b9ea441f0eb6422f2eb9514.webp";